import {
  getTypographyToken,
  ColorMode,
} from '@allergan-data-labs/alle-elements-core';

export const getTabBadgeStyles = (colorMode?: ColorMode) => ({
  ...getTypographyToken('Caption/Small/Medium'),
  display: 'inline-flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  color: `${colorMode}.Container/Neutral/Base`,
  backgroundColor: `${colorMode}.Container/Brand/Medium 2`,
  borderRadius: '.75rem',
  margin: '0.1875rem',
  width: '18px',
  height: '18px',
});
